import { useTranslation } from "react-i18next";
import {Consts} from "../../pages/consts";
import {buildInteractionParam} from "../../pages/utils";
import {phenotypeMap} from "../../../resources/json/jsons";
import i18n from "i18next";

const Recommendations = ({ risk, setRisk, showDialog, gene }) => {
  const { t } = useTranslation();
  let substance = JSON.parse(risk?.recommendation)[i18n.language?.toUpperCase()]?.substanceName;

  if(substance === ""){
    substance = risk.substanceKey;
  }

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-animate-zoom form-panel dialog-narrow">
        <label className="w3-margin bold-label">
          {t("recommendations_of_dpwg")} {t("for")} {gene?.geneName} {gene?.genotype}{" "}
          ({phenotypeMap[gene?.phenotype]}) {t("for")} {substance}
        </label>
        <div className="w3-container dialog-content-scroll">
          <label className="w3-margin">
            {risk
              ? buildInteractionParam(risk?.recommendation, true)
              : ""}
          </label>
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={() => setRisk(null)}
            >
              {t("close")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Recommendations;
